// whole application modules and submodules routes/paths
// Each Route/Module Shape

import { AccountBalance, Dashboard } from "@mui/icons-material";
import CalendarToday from "@mui/icons-material/CalendarToday";

//     assignable: false/true, // if module is available to attach with right(s)
//     path: "dummy-path", // path should be a unique string to render components dynamically
//     name: "Dummy Path", // name for the module
//     componentName: "DummyPath", // name of component which should be default export and must have same file name as component name. (it can be a file path to the component)
//     code: "DUMMY_PATH", // unique code among all modules/routes
//     childModules: [] //

//....................................... modules icons ......................................
const icons = {
  SUPPORT_PLAN_DASHBOARD: (
    <Dashboard className="icon icon-dashboard"></Dashboard>
  ),
  SUPPORT_PLAN: <i className="icon icon-wizard" />,
  SUSPENSION_MANAGER: <i className="icon icon-pause" />,
  FS_TOOLS: <i className="icon icon-fs-tools" />,
  BILLING_TOOLS: <AccountBalance className="icon icon-dashboard mb-2" />,
  SENSOR_MANAGER: <i className="icon icon-sensor-admin" />,
  SETTINGS: <i className="icon icon-settings" />,
  CALENDAR_VIEWER: <CalendarToday className="icon icon-calendar-viewer" />,
};
//...........................................................................................

//....................................... all modules routes ................................
const WizardRoutes = [
  {
    assignable: false,
    hide: false,
    path: "dashboard",
    name: "Dashboard",
    componentName: "Dashboard",
    code: "SUPPORT_PLAN_DASHBOARD",
    icon: icons.SUPPORT_PLAN_DASHBOARD,
    childModules: [],
  },
  {
    assignable: true,
    hide: false,
    path: "support-plan",
    name: "Support Plan",
    componentName: "Home",
    code: "SUPPORT_PLAN",
    icon: icons.SUPPORT_PLAN,
    childModules: [
      {
        hide: false,
        path: "support-plan/:clientId",
        name: "Client Support Plan",
        componentName: "SupportPlan",
        code: "CLIENT_SUPPORT_PLAN",
        icon: icons.SUPPORT_PLAN,
        childModules: [
          {
            name: "Name and Contact",
            descr: "Enter the client name and contact information",
            componentName: "AssignedClientPanel",
            code: "ASSIGNED_CLIENT",
            childModules: [],
          },
          {
            name: "Support Circle",
            descr:
              "Enter Case Managers, Guardians, HPC, County Board and Call Tree Information",
            componentName: "CareCircle",
            code: "SUPPORT_CIRCLE",
            childModules: [],
          },
          {
            name: "CS Rep",
            descr: "Enter Client Services Representative",
            componentName: "CSRepresentative",
            code: "CS_REPRESENTATIVE",
            childModules: [],
          },
          {
            name: "Emergency Planning",
            descr:
              "Enter Emergency Contact, Disaster & Emergency Plan Information",
            componentName: "EmergencyPlanning",
            code: "EMERGENCY_PLANNING",
            childModules: [],
          },
          {
            name: "Personal/Support Detail",
            descr: "Enter personal/support detail",
            componentName: "PersonalSupportDetails",
            code: "PERSONAL_SUPPORT_DETAILS",
            childModules: [],
          },
          {
            name: "Support Plan Actions",
            descr: "Define Support Plan Actions for the Client",
            componentName: "CarePlanActions",
            code: "CARE_PLAN_ACTIONS",
            childModules: [],
          },
          {
            name: "Support Plan Actions Calendar",
            descr: "Enter Support Plan Actions for the Calendar",
            componentName: "CarePlanActionsCalender",
            code: "CARE_PLAN_CALENDER",
            childModules: [],
          },
          {
            hide: true,
            name: "Calendar Heat Map",
            descr: "Calendar Heat Map View",
            componentName: "CalendarHeatMap",
            code: "CALENDER_HEAT_MAP",
            childModules: [],
          },
          {
            name: "Technology",
            descr: "Add/Remove technologies",
            componentName: "TechnologyDetails",
            code: "TECHNOLOGY_DETAILS",
            childModules: [],
          },
          {
            name: "Alert Conditions",
            descr: "Enter Alert Conditions",
            componentName: "AlertConditions",
            code: "ALERT_CONDITIONS",
            childModules: [],
          },
          {
            name: "Health Information",
            descr: "Enter Health Information for Client",
            componentName: "HealthInformation",
            code: "HEALTH_INFORMATION",
            childModules: [],
          },
          {
            name: "Generate Support Plan",
            descr: "Generate word document",
            componentName: "GenerateDocument",
            code: "GENERATE_DOCUMENT",
            childModules: [],
          },
          {
            name: "Suspension History",
            descr: "View suspension history",
            componentName: "SuspensionHistory",
            code: "SUSPENSION_HISTORY",
            childModules: [],
          },
          {
            name: "Support Plan Acknowledgement History",
            descr: "View Acknowledgement History",
            componentName: "SupportPlanAcknowledgementHistory",
            code: "SUPPORT_PLAN_ACKNOWLEDGEMENT_HISTORY",
            childModules: [],
          },
          {
            name: "Support Plan Individual Version History",
            descr: "Individual Version History",
            componentName: "IndividualVersionHistory",
            code: "SUPPORT_PLAN_INDIVIDUAL_VERSION_HISTORY",
            childModules: [],
          },
          {
            name: "Reported Client Sentiment Scores",
            descr: "View Reported Client Sentiment Scores",
            componentName: "SatisfactionScores",
            code: "SATISFACTION_SCORES",
            childModules: [],
          },
          {
            name: "Individual Communications Report",
            descr: "View Individual Communications Report",
            componentName: "CommunicationsReport",
            code: "INDIVIDUAL_COMMUNICATIONS_REPORT",
            childModules: [],
          },
          {
            name: "Billing History",
            descr: "View Billing History",
            componentName: "BillingHistory",
            code: "BILLING_HISTORY",
            childModules: [],
          },
          {
            name: "Objective / Checklist Report",
            descr: "View Objective / Checklist Report",
            componentName: "ObjectiveChecklistReport",
            code: "OBJECTIVE_CHECKLIST_REPORT",
            childModules: [],
          },
        ],
      },
    ],
  },
];
const SuspensionManagerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "suspension-manager",
    name: "Suspension Manager",
    componentName: "SuspensionManager",
    code: "SUSPENSION_MANAGER",
    icon: icons.SUSPENSION_MANAGER,
    childModules: [
      {
        assignable: true,
        hide: false,
        path: "add-new-suspension",
        name: "Add New Suspension",
        componentName: "",
        code: "BTN_ADD_NEW_SUSPENSION", // it's a button
        icon: icons.SUSPENSION_MANAGER,
        childModules: [],
      },
      {
        assignable: true,
        hide: false,
        path: "clean-up-removal-queue",
        name: "Clean Up Removal Queue",
        componentName: "",
        code: "BTN_CLEAN_UP_REMOVAL_QUEUE",
        icon: icons.SUSPENSION_MANAGER,
        childModules: [],
      },
    ],
  },
];
const FSToolsRoutes = [
  {
    assignable: true,
    hide: false,
    path: "fs-tools",
    name: "FS Tools",
    componentName: "FSTools",
    code: "FS_TOOLS",
    icon: icons.FS_TOOLS,
    childModules: [
      {
        name: "Geocomm Utilities",
        descr: "geocomm utilities",
        path: "geocomm-pendant",
        componentName: "",
        code: "GEOCOMM_UTILITIES",
        childModules: [
          {
            name: "Geocomm Maintenance",
            descr: "geocomm maintenance",
            path: "geocomm-maintenance",
            componentName: "GeoCommPendantPing",
            code: "GEOCOMM_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Geocomm Wristband",
        descr: "geocomm wristband",
        path: "geocomm-wristband",
        componentName: "",
        code: "GEOCOMM_WRISTBAND",
        childModules: [
          {
            name: "Provision GeoComm Device",
            descr: "provision geoComm device",
            path: "provision-device",
            componentName: "ProvisionWristband",
            code: "PROVISION_GEOCOMM_DEVICE",
            childModules: [],
          },
          {
            name: "Wristband Contacts",
            descr: "wristband contacts",
            path: "wristband-contacts",
            componentName: "WristbandContacts",
            code: "WRISTBAND_CONTACTS",
            childModules: [],
          },
          {
            name: "Wristband Geofence",
            descr: "wristband geofence",
            path: "wristband-geofence",
            componentName: "WristbandGeofence",
            code: "WRISTBAND_GEOFENCE",
            childModules: [],
          },
          {
            name: "Generate Short Token",
            descr: "generate short token",
            path: "short-token-generator",
            componentName: "ShortTokenGenerator",
            code: "GENERATE_SHORT_TOKEN",
            childModules: [],
          },
          {
            name: "Reboot Wristband",
            descr: "reboot wristband",
            path: "reboot-wristband",
            componentName: "WristbandReboot",
            code: "REBOOT_WRISTBAND",
            childModules: [],
          },
        ],
      },
      {
        name: "Shinobi Camera Configuration",
        descr: "shinobi camera configuration",
        path: "shinobi-camera",
        componentName: "",
        code: "SHINOBI_CAMERA",
        childModules: [
          {
            name: "Shinobi Camera Configuration",
            descr: "shinobi camera configuration",
            path: "shinobi-camera-configuration",
            componentName: "ShinobiCameraConfiguration",
            code: "SHINOBI_CAMERA_CONFIG",
            childModules: [],
          },
          {
            name: "Support Center Tabs Configuration",
            descr: "support center tabs configuration",
            path: "support-center-tabs",
            componentName: "SupportCenterTabs",
            code: "SUPPORT_CENTER_TABS",
            childModules: [],
          },
        ],
      },
      {
        name: "Foscam Camera Configuration",
        descr: "foscam camera configuration",
        path: "foscam-camera",
        componentName: "",
        code: "FOSCAM_CAMERA",
        childModules: [
          {
            name: "Foscam Camera Configuration",
            descr: "foscam camera configuration",
            path: "foscam-camera-configuration",
            componentName: "FoscamCameraConfiguration",
            code: "FOSCAM_CAMERA_CONFIG",
            childModules: [],
          },
        ],
      },
      {
        name: "iGuard Stove",
        descr: "iGuard Stove",
        path: "iguard-stove",
        componentName: "",
        code: "IGUARD_STOVE",
        childModules: [
          {
            name: "Provision iGuard Device",
            descr: "provision iGuard device",
            path: "provision-iguard-device",
            componentName: "ProvisionIGuard",
            code: "PROVISION_IGUARD_DEVICE",
            childModules: [],
          },
        ],
      },
      {
        name: "Sensor System Utilities",
        descr: "sensor system utilities",
        path: "sensor-system-utilities",
        componentName: "",
        code: "SENSOR_SYSTEM_UTILITIES",
        childModules: [
          {
            name: "Provision Sensor System",
            descr: "provision sensor system",
            path: "provision-sensor-system",
            componentName: "ProvisionSensorSystem",
            code: "PROVISION_SENSOR_SYSTEM",
            childModules: [],
          },
        ],
      },
      {
        name: "Sensor Status Tools",
        descr: "sensor status tools",
        path: "sensor-status-tools",
        componentName: "",
        code: "SENSOR_STATUS_TOOLS",
        childModules: [
          {
            name: "Sensor System Message Status",
            descr: "sensor system message status",
            path: "sensor-system-message-status",
            componentName: "SensorSystemMessageStatus",
            code: "SENSOR_SYSTEM_MESSAGE_STATUS",
            childModules: [],
          },
          {
            name: "Sensor Outage Status",
            descr: "sensor outage status",
            path: "sensor-outage-status",
            componentName: "SensorSystemOutageStatus",
            code: "SENSOR_OUTAGE_STATUS",
            childModules: [],
          },
          {
            name: "IUS Sensor Status",
            descr: "ius sensor status",
            path: "ius-sensor-status",
            componentName: "IUSSensorStatus",
            code: "IUS_SENSOR_STATUS",
            childModules: [],
          },
        ],
      },
      {
        name: "Tablet Dashboard",
        descr: "tablet dashboard",
        path: "tablet-dashboard",
        componentName: "",
        code: "TABLET_DASHBOARD",
        childModules: [
          {
            name: "Battery Level and Online Status",
            descr: "battery level and online status",
            path: "tablet-charts",
            componentName: "TabletDashboard",
            code: "BATTERY_LEVEL",
            childModules: [],
          },
          {
            name: "Device Grid",
            descr: "device grid",
            path: "tablet-grid",
            componentName: "DeviceGridDashboard",
            code: "DEVICE_GRID",
            childModules: [],
          },
        ],
      },
      {
        name: "Tablet Utilities",
        descr: "tablet utilities",
        path: "tablet-utilities",
        componentName: "",
        code: "TABLET_UTILITIES",
        childModules: [
          {
            name: "Tablet Maintenance",
            descr: "tablet maintenance",
            path: "tablet-maintenance",
            componentName: "TabletMaintenance",
            code: "TABLET_MAINTENANCE",
            childModules: [],
          },
        ],
      },
    ],
  },
];
const BillingToolsRoutes = [
  {
    assignable: true,
    hide: false,
    path: "billing-tools",
    name: "Billing Tools",
    componentName: "BillingTools",
    code: "BILLING_TOOLS",
    icon: icons.BILLING_TOOLS,
    childModules: [
      {
        name: "EMBS File Management",
        descr: "EMBS file management",
        path: "embs-file-management",
        componentName: "",
        code: "EMBS_FILE_MANAGEMENT",
        childModules: [
          {
            name: "Upload Weekly EMBS file",
            descr: "upload weekly EMBS file",
            path: "upload-weekly-embs-file",
            componentName: "EMBSWeeklyFile",
            code: "UPLOAD_WEEKLY_EMBS_FILE",
            childModules: [],
          },
        ],
      },
      {
        name: "Client Billing Management",
        descr: "client billing management",
        path: "embs-client-management",
        componentName: "",
        code: "EMBS_CLIENT_MANAGEMENT",
        childModules: [
          {
            name: "Edit Billing Parameters",
            descr: "edit billing parameters",
            path: "edit-billing-parameters",
            componentName: "EMBSUserBillingParameters",
            code: "EDIT_BILLING_PARAMETERS",
            childModules: [],
          },
        ],
      },
      {
        name: "Billing Data",
        descr: "Billing Data",
        path: "billing-data",
        componentName: "",
        code: "BILLING_DATA",
        childModules: [
          {
            name: "Billing Week Summary",
            descr: "Billing Week Summary",
            path: "billing-week-summary",
            componentName: "BillingWeekSummary",
            code: "BILLING_WEEK_SUMMARY",
            childModules: [],
          },
        ],
      },
    ],
  },
];
const SensorManagerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "sensor-manager",
    name: "Sensor Manager",
    componentName: "SensorManager",
    code: "SENSOR_MANAGER",
    icon: icons.SENSOR_MANAGER,
    childModules: [],
  },
];
const AppSettingRoutes = [
  {
    assignable: true,
    hide: false,
    path: "settings",
    name: "Settings",
    componentName: "Settings",
    code: "SETTINGS",
    icon: icons.SETTINGS,
    childModules: [
      {
        name: "Application Settings",
        descr: "Application Settings",
        path: "app-settings",
        componentName: "",
        code: "APPLICATION_SETTINGS",
        childModules: [
          /*{
                          name: "Associate Products",
                          descr: "Associate Products",
                          path: "associate-products",
                          componentName: "AssociateProducts/AssociateProducts",
                          code: "ASSOCIATE_PRODUCTS",
                          childModules: []
                      },*/
          {
            name: "Special Handling Message Banners ",
            descr: "Special Handling Banners",
            path: "handling-banners",
            componentName: "SpecialHandlingManager/SpecialHandlingBanners",
            code: "SPECIAL_HANDLING_MANAGER",
            childModules: [],
          },
          {
            name: "Global Announcements",
            descr: "Global Announcements",
            path: "global-announcements",
            componentName: "GlobalAnnouncements/GlobalAnnouncements",
            code: "GLOBAL_ANNOUNCEMENTS",
            childModules: [],
          },
          {
            name: "Communication Methods",
            descr: "Communication Methods",
            path: "communication-methods",
            componentName: "CommunicationMethods/CommunicationMethods",
            code: "COMMUNICATION_METHODS",
            childModules: [],
          },
          {
            name: "Command Center Tiles",
            descr: "Command Center Tiles Management",
            path: "command-center-tiles",
            componentName: "CommandCenter/CommandCenterTileList",
            code: "COMMAND_CENTER_TILES",
            childModules: [],
          },
        ],
      },
      {
        name: "User Administration",
        descr: "User Administration",
        path: "user-admin",
        componentName: "",
        code: "USER_ADMINISTRATION",
        childModules: [
          {
            name: "User Administration Maintenance ",
            descr: "User Administration Maintenance ",
            path: "user-maintenance",
            componentName: "UserAdmin/UserMaintenance",
            code: "USER_ADMINISTRATION_MAINTENANCE",
            childModules: [],
          },
          {
            name: "SSO Association Maintenance ",
            descr: "SSO Association Maintenance ",
            path: "sso-maintenance",
            componentName: "UserAdmin/SSOAssociationMaintenance",
            code: "SSO_ASSOCIATION_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Application Administration",
        descr: "Application Administration",
        path: "app-admin",
        componentName: "",
        code: "APPLICATION_ADMINISTRATION",
        childModules: [
          {
            name: "User Right(s) Maintenance ",
            descr: "User Right(s) Maintenance ",
            path: "right-maintenance",
            componentName: "UserAdmin/RightMaintenance",
            code: "USER_RIGHTS_MAINTENANCE",
            childModules: [],
          },
          {
            name: "User Role(s) Maintenance ",
            descr: "User Role(s) Maintenance ",
            path: "role-maintenance",
            componentName: "UserAdmin/RoleMaintenance",
            code: "USER_ROLES_MAINTENANCE",
            childModules: [],
          },
          {
            name: "System Tag Maintenance ",
            descr: "System Tag Maintenance  ",
            path: "system-tag-maintenance",
            componentName: "UserAdmin/SystemTagMaintenance",
            code: "SYSTEM_TAG_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Language Maintenance ",
            descr: "Language Maintenance  ",
            path: "language-maintenance",
            componentName: "UserAdmin/LanguageMaintenance",
            code: "LANGUAGE_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Tablet Notification Configuration",
            descr: "Tablet Notification Configuration",
            path: "tablet-notification-configuration",
            componentName: "UserAdmin/TabletNotificationConfiguration",
            code: "TABLET_NOTIFICATION_CONFIGURATION",
            childModules: [],
          },
        ],
      },
      {
        name: "Application Logs",
        descr: "Application Logs",
        path: "logs",
        componentName: "",
        code: "APPLICATION_LOGS",
        childModules: [
          {
            name: "Support Plan Logs",
            descr: "Support Plan Logs",
            path: "support-plan",
            componentName: "UserAdmin/AdminUserSupportPlanLogs",
            code: "SUPPORT_PLAN_LOGS",
            childModules: [],
          },
        ],
      },
      {
        name: "Quality of Life Survey Administration",
        descr: "QoL Survey Administration",
        path: "obj-admin",
        componentName: "",
        code: "QOL_ADMINISTRATION",
        childModules: [
          {
            name: "Question Maintenance ",
            descr: "Question Maintenance ",
            path: "qol-maintenance",
            componentName: "QoLMaintenance/QolMaintenance",
            code: "QOL_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Answer Maintenance ",
            descr: "Answer Maintenance ",
            path: "answer-maintenance",
            componentName: "QoLMaintenance/AnswerMaintenance",
            code: "ANSWER_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Objectives Administration",
        descr: "Objectives Administration",
        path: "obj-admin",
        componentName: "",
        code: "OBJ_ADMINISTRATION",
        childModules: [
          {
            name: "Objectives Maintenance ",
            descr: "Objectives Maintenance ",
            path: "obj-maintenance",
            componentName: "ObjectiveMaintenance/ObjectiveMaintenance",
            code: "OBJECTIVES_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Checklist Administration",
        descr: "Checklist Administration",
        path: "checklist-admin",
        componentName: "",
        code: "CHECKLIST_ADMIN",
        childModules: [
          {
            name: "Checklist Maintenance ",
            descr: "Checklist Maintenance ",
            path: "checklist-maintenance",
            componentName: "ChecklistMaintenance/ChecklistMaintenance",
            code: "CHECKLIST_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Five9 Administration",
        descr: "Five9 Administartion",
        path: "five9-administration",
        componentName: "",
        code: "FIVE9_ADMIN",
        childModules: [
          {
            name: "Unverified Number Maintenance",
            desc: "Unverified Number Maintenance",
            path: "unverified-numbers",
            componentName: "Five9Administration/UnverifiedNumbers",
            code: "UNVERIFIED_NUMBER_MAINTENANCE",
            childModules: [],
          },
        ],
      },
      {
        name: "Dashboard Administration",
        descr: "Dashboard Administration",
        path: "dashboard-admin",
        componentName: "",
        code: "DASHBOARD_ADMIN",
        childModules: [
          {
            name: "Dashboard Page Maintenance",
            descr: "Dashboard Page Maintenance",
            path: "dashboard-page-maintenance",
            componentName:
              "DashboardAdmin/DashboardPageMaintenance/DashboardPageMaintenance",
            code: "DASHBOARD_PAGE_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Dashboard Function Maintenance",
            descr: "Dashboard Function Maintenance",
            path: "dashboard-function-maintenance",
            componentName:
              "DashboardAdmin/DashboardFunctionMaintenance/DashboardFunctionMaintenance",
            code: "DASHBOARD_FUNCTION_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Dashboard Object Types",
            descr: "Dashboard Object Types",
            path: "dashboard-object-types",
            componentName:
              "DashboardAdmin/DashboardObjectTypes/DashboardObjectTypes",
            code: "DASHBOARD_OBJECT-TYPES",
            childModules: [],
          },
          {
            name: "Dashboard Page Objects",
            descr: "Dashboard Page Objects",
            path: "dashboard-page-objects",
            componentName:
              "DashboardAdmin/DashboardPageObjects/DashboardPageObjects",
            code: "DASHBOARD_PAGE_OBJECTS",
            childModules: [],
          },
          {
            name: "Dashboard Page Builder",
            desc: "dashboard page builder",
            path: "dashboard-page-builder",
            componentName:
              "DashboardAdmin/DashboardPageBuilder/DashboardPageBuilder",
            code: "DASHBOARD_PAGE_BUILDER",
            childModules: [],
          },
        ],
      },
      {
        name: "Sentiment Scoring Administration",
        descr: "Sentiment Scoring Administration",
        path: "sentiment-admin",
        componentName: "",
        code: "SENTIMENT_ADMIN",
        childModules: [
          {
            name: "Sentiment Maintenance",
            desc: "Sentiment Maintenance",
            path: "sentiment-maintenance",
            componentName: "SentimentScoring/SentimentMaintenance",
            code: "SENTIMENT_MAINTENANCE",
            childModules: [],
          },
        ],
      },
    ],
  },
];
const IUSSensorRoutes = [
  {
    assignable: false,
    hide: false,
    path: "ius-sensor/:externUserCode/:clientName/:agentUsersId/:token",
    name: "IUS Sensor",
    componentName: "IUSSensor",
    code: "IUS_SENSOR",
    childModules: [],
  },
];
const AuthFromTokenRoutes = [
  {
    assignable: false,
    path: "auth/:usersId/",
    componentName: "AuthFromToken",
    code: "AUTH_FROM_TOKEN",
  },
];
const CalendarViewerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "calendar-viewer/:usersId",
    name: "Calendar Viewer",
    componentName: "CalendarViewer",
    code: "CALENDAR_VIEWER",
    icon: icons.CALENDAR_VIEWER,
  },
];
//................................................................................

const filteredRoutes = [
  ...WizardRoutes,
  ...SuspensionManagerRoutes,
  ...FSToolsRoutes,
  ...BillingToolsRoutes,
  ...SensorManagerRoutes,
  ...AppSettingRoutes,
  ...IUSSensorRoutes,
  ...CalendarViewerRoutes,
  ...AuthFromTokenRoutes,
].filter((route) => !route.hide);
export const AllRoutes = filteredRoutes;
